<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.5C17.85 1.5 22.5 6.15 22.5 12C22.5 17.85 17.85 22.5 12 22.5C6.15 22.5 1.5 17.85 1.5 12C1.5 6.15 6.15 1.5 12 1.5ZM12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0Z"
      fill="#444444"
    />
    <path d="M4.5 10.5H19.5V13.5H4.5V10.5Z" fill="#444444" />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
